"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaboratorButton = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CollaboratorButton = (function (_super) {
    __extends(CollaboratorButton, _super);
    function CollaboratorButton(props) {
        return _super.call(this, props) || this;
    }
    CollaboratorButton.prototype.render = function () {
        var _a = this.props, collaboratorLink = _a.collaboratorLink, telemetryCallback = _a.telemetryCallback, _b = _a.type, type = _b === void 0 ? kaleidoscope_2.ButtonType.Primary : _b, _c = _a.buttonState, buttonState = _c === void 0 ? kaleidoscope_2.ButtonState.Idle : _c, width = _a.width;
        return (react_1.default.createElement(kaleidoscope_1.CopyToClipboard, { value: collaboratorLink, showTooltipOnCopy: true }, function (_a) {
            var onCopy = _a.onCopy;
            return (react_1.default.createElement(kaleidoscope_2.Button, { type: type, className: "collaborator-button__copy-link", width: width, buttonState: buttonState, onClick: function () {
                    onCopy();
                    telemetryCallback();
                } },
                react_1.default.createElement(icons_1.Team, null),
                "Copy collaborator link"));
        }));
    };
    return CollaboratorButton;
}(react_1.default.Component));
exports.CollaboratorButton = CollaboratorButton;
